import DrGBalasubramaniaRaja from "../../../assets/Research/DrGBalasubramaniaRaja.png";
import DrKAJanardhanan from "../../../assets/Research/DrKAJanardhanan.png";
import DrRMarimuthu from "../../../assets/Research/DrRMarimuthu.png";
import DrRRajalakshmi from "../../../assets/Research/DrRRajalakshmi.png";
import DrTCitarasu from "../../../assets/Research/DrTCitarasu.png";

export const editorialFacultyData = [
    {
        image: DrRMarimuthu,
        name: "Dr.R.Marimuthu",
        role: "Editor-in-Chief",
        details: [
            "Dr. R. Marimuthu, M.Com., M.Phil., Ph.D., MBA., PGDPM & IR,",
            "Principal & Associate Professor,",
            "Noorul Islam College of Arts & Science, Kumaracoil, Thuckalay,",
            "Kanyakumari District, Tamil Nadu - 629180,",
            "Email: balumarimuthukarur@gmail.com"
        ]
    },
    {
        image: DrKAJanardhanan,
        name: "Dr.K.A.Janardhanan",
        role: "Co-Editor-in-Chief",
        details: [
            "Dr. K. A. Janardhanan, M.B.A., M.A., M.Phil., Ph.D. (Management), Ph.D. (Public Administration).,",
            "Pro Vice-Chancellor (Administration) and Member, Board of Management,",
            "Noorul Islam Centre for Higher Education, Kumaracoil, Thuckalay,",
            "Kanyakumari District, Tamil Nadu - 629180,",
            "Email: pvcad@niuniv.com"
        ]
    },
    {
        image: DrGBalasubramaniaRaja,
        name: "Dr.G.BalasubramaniaRaja",
        role: "Co-Editor-in-Chief",
        details: [
            "Dr. G. Balasubramania Raja, M.A., M.Phil., Ph.D.,",
            "Director, Centre for Research; Professor and Head,",
            "Department of Communication,",
            "Manonmaniam Sundaranar University,",
            "Tirunelveli - 627012,",
            "Email: hodcommunication@msuniv.ac.in"
        ]
    },
    {
        image: DrTCitarasu,
        name: "Dr.T.Citarasu",
        role: "Co-Editor-in-Chief",
        details: [
            "Dr. T. Citarasu, MSc., M.Phil., Ph.D.,",
            "Associate Professor, Centre for Marine Science and Technology,",
            "Manonmaniam Sundaranar University, Rajakkamangalam,",
            "Kanyakumari District, Tamil Nadu, India - 629502,",
            "Email: citarasu@msuniv.ac.in"
        ]
    },
    {
        image: DrRRajalakshmi,
        name: "Dr.R.Rajalakshmi",
        role: "Co-Editor-in-Chief",
        details: [
            "Dr. R. Rajalakshmi, MSc., M.Phil., Ph.D.,",
            "Assistant Professor & Head, Department of Computer Science,",
            "Noorul Islam College of Arts & Science, Kumaracoil, Thuckalay,",
            "Kanyakumari District, Tamil Nadu - 629180,",
            "Email: 2001rajalakshmi.cs@nicollege.com"
        ]
    }
];
